// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialShareDeliverables_root__L9u_1","submitButton":"SocialShareDeliverables_submitButton__2cl34"};